import React from 'react';

type Props = {
  className?: string;
  height?: number;
  width?: number;
};

const Icon: React.FC<Props> = ({ className, height = 4, width = 16 }: Props) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_20262_12236_horizon_more)">
      <rect width="20" height="20" rx="10" fill="#F5F5F5" />
      <mask
        id="mask0_20262_12236_horizon_more"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_20262_12236_horizon_more)">
        <path
          d="M9.16675 10.8337H4.16675V9.16699H9.16675V4.16699H10.8334V9.16699H15.8334V10.8337H10.8334V15.8337H9.16675V10.8337Z"
          fill="#333333"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_20262_12236_horizon_more">
        <rect width="20" height="20" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Icon;
